import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { motion } from 'framer-motion';
import { Clock, Flame, Play } from 'lucide-react';
import { getDifficultyLabel } from '../../utils/constants';

export const WorkoutPreviewSidebar = ({ workout, isNew, id }) => {
  return (
    <div className="space-y-6">
      {/* Preview Card */}
      <motion.div 
        initial={{ opacity: 0, x: 20 }}
        animate={{ opacity: 1, x: 0 }}
        className="bg-card border border-border p-6"
      >
        <h3 className="font-heading text-xl text-white uppercase tracking-wider mb-4">Preview</h3>
        <div className="bg-black border border-border p-4">
          <div className="flex items-center gap-2 mb-2">
            <Badge className="bg-primary/20 text-primary">{workout.category}</Badge>
            <Badge className="bg-white/10 text-white">{getDifficultyLabel(workout.difficulty)}</Badge>
          </div>
          <h4 className="font-heading text-lg text-white uppercase tracking-wider mb-1">{workout.title}</h4>
          <div className="flex items-center gap-4 text-muted-foreground text-sm">
            <span className="flex items-center gap-1">
              <Clock className="h-4 w-4" />
              {workout.duration_minutes} min
            </span>
            <span className="flex items-center gap-1">
              <Flame className="h-4 w-4" />
              {workout.calories_burn} cal
            </span>
          </div>
        </div>
      </motion.div>

      {/* Quick Stats */}
      <motion.div 
        initial={{ opacity: 0, x: 20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.1 }}
        className="bg-card border border-border p-6"
      >
        <h3 className="font-heading text-xl text-white uppercase tracking-wider mb-4">Stats</h3>
        <div className="space-y-3">
          <div className="flex items-center justify-between p-3 bg-black border border-border">
            <span className="text-muted-foreground">Exercises</span>
            <span className="text-white font-heading">{workout.exercises?.length || 0}</span>
          </div>
          <div className="flex items-center justify-between p-3 bg-black border border-border">
            <span className="text-muted-foreground">Total Sets</span>
            <span className="text-white font-heading">
              {workout.exercises?.reduce((acc, ex) => acc + (ex.sets || 0), 0) || 0}
            </span>
          </div>
          <div className="flex items-center justify-between p-3 bg-black border border-border">
            <span className="text-muted-foreground">Has Video</span>
            <span className={`font-heading ${workout.video_url ? 'text-green-400' : 'text-muted-foreground'}`}>
              {workout.video_url ? 'Yes' : 'No'}
            </span>
          </div>
        </div>
      </motion.div>

      {/* Actions */}
      {!isNew && (
        <motion.div 
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.2 }}
          className="bg-card border border-border p-6"
        >
          <h3 className="font-heading text-xl text-white uppercase tracking-wider mb-4">Actions</h3>
          <Link to={`/workout/${id}`} target="_blank">
            <Button variant="outline" className="w-full border-white/20 text-white hover:bg-white/10">
              <Play className="h-4 w-4 mr-2" />
              Preview Workout
            </Button>
          </Link>
        </motion.div>
      )}
    </div>
  );
};
